export const config = {
  rowSelection: false,
  fieldControl: false,
  pagination: false,
  tableType: 'antd',
  columns: [
    {
      title: '编码',
      dataIndex: ['object', 'priKey'],
      width: 200,
      ellipsis: true
    },
    {
      title: '名称',
      dataIndex:['object', 'name'],
      width: 200,
      ellipsis: true
    },
    {title: '值', dataIndex: ['object', 'dataValue'], width: 180, ellipsis: true},
    {title: '扩展字段', dataIndex: ['object', 'extFirstField'], width: 180, ellipsis: true},
    {title: '排序', dataIndex: ['object', 'sortNumber'], width: 100, ellipsis: true},
    {title: '描述', dataIndex: ['object', 'description'], width: 200, render: 'ellipsisRender'},
    {
      title: '创建人',
      dataIndex: ['object', 'createdByName'],
      width: 160,
    },
    {
      title: '创建时间',
      dataIndex: ['object', 'createdTime'],
      width: 160,
      itemType: 'dateTime'
    },
    {
      title: '状态',
      dataIndex: ['object', 'enabled'],
      width: 100,
      render: 'switchRender'
    },
    {
      title: '操作',
      dataIndex: 'actions',
      width: 130,
      render: 'actionRender',
      fixed: 'right',
    },
  ],
  search: [
    {
      name: 'keyName',
      label: '名称',
    },
    {
      label: '状态',
      name: 'enabled',
      itemType: 'select',
      labelKey: 'label',
      key: 'value',
      data: [
        {label: '启用', value: true},
        {label: '禁用', value: false},
      ],
    },
  ],
  footer: [
    {
      label: '添加字段',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
  ],
  batchActions: [],
}
